import { Col, Row } from 'antd';
import React from 'react';

import PageHeader from '@/components/PageHeader';

import EquipmentInspectionManagement from './components/EquipmentInspectionManagement';

const EquipmentInspection = () => {
  return (
    <Row>
      <Col span={24}>
        <PageHeader
          title="機電巡檢管理"
          breadcrumbs={[
            {
              name: '機電巡檢',
            },
            {
              name: '機電巡檢管理',
            },
          ]}
        />
        <EquipmentInspectionManagement />
      </Col>
    </Row>
  );
};

export default EquipmentInspection;
